import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'

const ImageSwitcher = ({
  image0,
  image1,
  isListView
}: {
  image0: string
  image1: string
  isListView: boolean
}) => {
  const [hoveredSection, setHoveredSection] = useState(null)

  const handleMouseEnter = (section: any) => {
    setHoveredSection(section)
  }

  const handleMouseLeave = () => {
    setHoveredSection(null)
  }

  let defaultHeight = '276px'

  if (isListView) {
    defaultHeight = isMobile ? '130px' : '200px'
  }

  // @ts-ignore
  return (
    <div style={{
      display: 'flex',
      height: defaultHeight,
      width: '100%',
      borderRadius: '8px',
      position: 'relative',
      backgroundImage: `url(${hoveredSection === 'right' ? image1 : image0})`,
      backgroundSize: 'cover',
    }}>
      <div
        style={{
          flex: 1,
          borderBottom: hoveredSection === 'left' ? '3px solid red' : 'none'
        }}
        onMouseEnter={() => handleMouseEnter('left')}
        onMouseLeave={handleMouseLeave}
      />
      <div
        style={{
          flex: 1,
          borderBottom: hoveredSection === 'right' ? '3px solid red' : 'none'
        }}
        onMouseEnter={() => handleMouseEnter('right')}
        onMouseLeave={handleMouseLeave}
      />
    </div>
  )
}

export default ImageSwitcher
